
import { useEffect, useState } from 'react';
import { SocialNetworksService } from '../../services/socialNetworkService';
import './social-networks.scss';
import { icon } from '../../utils/constants/icon';

export function SocialNetworks(){
        const[icons,setIcons] = useState<any[]>([])
        const socialNetworksService= SocialNetworksService();

        useEffect(()=>{
            const fetchIcons = async ()=>{
                try{
                    const iconDatas:any = await socialNetworksService.getLinks();
                    setIcons(iconDatas.data);
                }catch(err){
                    console.error(err)
                }
            }
            fetchIcons();
        },[])
    return(
        <>
            <div className='flex'>
                <ul className='flex align-center social-network-list'>
                    {   
                        icons.map(({url,icon_url,label},id) =>

                        <li key={id}>
                            <a href={url} target='_blank' rel="noopener noreferrer"><img src={icon_url} alt={label} width={icon.maxWidth} height={icon.maxHeight} /></a>
                        </li>
            
                        )
                    }
                </ul>
            </div>
        </>
    )
}